var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3A712314-24D5-43ED-BCAF-CF3216B8DF66") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomepageOK-1080px",
    transform: "translate(-1084.000000, -5748.000000)",
    fill: "#FDC609",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandeau-boost",
    transform: "translate(0.000000, 5602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(854.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facile",
    transform: "translate(180.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag",
    transform: "translate(50.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6757812,35.3515625 L23.5351562,35.3515625 L23.5351562,26.3671875 L45.6054688,26.3671875 C46.7745117,26.3671875 47.471582,25.0607422 46.8243164,24.0897461 L41.5094727,16.1174805 L46.8203125,8.23417969 C47.4742188,7.26357422 46.7774414,5.95087891 45.6054688,5.95087891 L26.1791992,5.95087891 C26.3631836,5.46679688 26.4648438,4.94238281 26.4648438,4.39453125 C26.4648438,1.97138672 24.493457,0 22.0703125,0 C19.647168,0 17.6757812,1.97138672 17.6757812,4.39453125 C17.6757812,6.30419922 18.9004883,7.93242188 20.6054688,8.53710938 L20.6054688,35.3515625 L7.32421875,35.3515625 C3.28564453,35.3515625 0,38.637207 0,42.6757812 C0,46.7143555 3.28564453,50 7.32421875,50 L42.6757812,50 C46.7143555,50 50,46.7143555 50,42.6757812 C50,38.637207 46.7143555,35.3515625 42.6757812,35.3515625 Z M42.8524414,8.88066406 L38.53125,15.2948242 C38.1994141,15.7874023 38.1978516,16.4316406 38.5272461,16.9257812 L42.8683594,23.4375 L23.5351562,23.4375 L23.5351562,8.88066406 L42.8524414,8.88066406 Z M22.0703125,2.9296875 C22.8780273,2.9296875 23.5351562,3.58681641 23.5351562,4.39453125 C23.5351562,5.20224609 22.8780273,5.859375 22.0703125,5.859375 C21.2625977,5.859375 20.6054688,5.20224609 20.6054688,4.39453125 C20.6054688,3.58681641 21.2625977,2.9296875 22.0703125,2.9296875 Z M42.6757812,47.0703125 L7.32421875,47.0703125 C4.90107422,47.0703125 2.9296875,45.0989258 2.9296875,42.6757812 C2.9296875,40.2526367 4.90107422,38.28125 7.32421875,38.28125 L20.6054688,38.28125 L20.6054688,41.2109375 L19.140625,41.2109375 C18.3316406,41.2109375 17.6757812,41.8667969 17.6757812,42.6757812 C17.6757812,43.4847656 18.3316406,44.140625 19.140625,44.140625 L25,44.140625 C25.8089844,44.140625 26.4648438,43.4847656 26.4648438,42.6757812 C26.4648438,41.8667969 25.8089844,41.2109375 25,41.2109375 L23.5351562,41.2109375 L23.5351562,38.28125 L42.6757812,38.28125 C45.0989258,38.28125 47.0703125,40.2526367 47.0703125,42.6757812 C47.0703125,45.0989258 45.0989258,47.0703125 42.6757812,47.0703125 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.59e246dc5fde7b7763c2ca9d8632a641.svg";
export { ForwardRef as ReactComponent };